import { Formik } from 'formik'
import { ModalWrapper } from 'src/components'
import { useAccountChangeOwnerManual } from 'src/hooks'
import { OwnerChangeContent } from './content.component'

import { useStyles } from './styles'

interface IProps {
  accountId: string | null
  handleClose: () => void
}

export const AccountOwnerChangeModal = ({ accountId, handleClose }: IProps) => {
  const classes = useStyles()
  const { mutateAsync: updateOwner } = useAccountChangeOwnerManual(accountId)

  const handleSubmit = async (values: { email: string }) => {
    const resp = await updateOwner({
      email: values.email,
    })
    if (!resp) return
    handleClose()
  }

  return (
    <ModalWrapper open={!!accountId} onClose={handleClose} className={classes.ownerInputModal}>
      <Formik initialValues={{ email: '' }} onSubmit={handleSubmit}>
        <OwnerChangeContent />
      </Formik>
    </ModalWrapper>
  )
}
